"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineLanguages = void 0;
const libs_router_config_1 = require("@hotelplan/libs.router-config");
const fdr_lib_i18n_lang_page_props_1 = require("@hotelplan/fdr.lib.i18n.lang-page-props");
const fdr_lib_i18n_lang_route_1 = require("@hotelplan/fdr.lib.i18n.lang-route");
function getRouteLanguages(pageProps) {
    const routeProp = (0, libs_router_config_1.getRoutePageProp)(pageProps);
    return routeProp ? (0, fdr_lib_i18n_lang_route_1.createRouteLanguageUrls)(routeProp) : {};
}
function hasUrls(urls) {
    if (!urls || typeof urls !== 'object')
        return false;
    return Object.keys(urls).length > 0;
}
function prepareLinks(origin, routeUrls) {
    return function (urlsFromProps) {
        return (0, fdr_lib_i18n_lang_route_1.mapLinksToLanguageUrls)(origin, routeUrls, urlsFromProps);
    };
}
function buildResult(urls, lang) {
    return function (alternativeUrls) {
        return {
            urls,
            canonical: alternativeUrls[lang] || null,
            alternativeUrls,
        };
    };
}
function defineLanguages(pageProps, addCanonical, language) {
    const routeProp = (0, libs_router_config_1.getRoutePageProp)(pageProps);
    const languageUrlsProp = (0, fdr_lib_i18n_lang_page_props_1.getPageLanguages)(pageProps);
    const routeUrls = getRouteLanguages(pageProps);
    const createLangUrlsFn = prepareLinks(routeProp.origin, routeUrls);
    const languageUrlsOnly = createLangUrlsFn(hasUrls(languageUrlsProp)
        ? (0, fdr_lib_i18n_lang_route_1.fallbackLanguageURLsToHome)(languageUrlsProp)
        : {});
    const urls = Object.assign(Object.assign({}, routeUrls), languageUrlsOnly);
    const doResultFn = buildResult(urls, language);
    if (!addCanonical) {
        return { urls, canonical: null, alternativeUrls: {} };
    }
    const canonicalUrls = createLangUrlsFn((0, fdr_lib_i18n_lang_page_props_1.getCanonicalLanguages)(pageProps));
    if (hasUrls(canonicalUrls)) {
        return doResultFn(canonicalUrls);
    }
    const pureLanguageUrls = (0, fdr_lib_i18n_lang_route_1.omitFallbackLinks)(languageUrlsProp);
    if (hasUrls(pureLanguageUrls)) {
        const pureUrls = createLangUrlsFn(pureLanguageUrls);
        return doResultFn(pureUrls);
    }
    return doResultFn(routeUrls);
}
exports.defineLanguages = defineLanguages;
//# sourceMappingURL=lang.util.js.map